import { Injectable } from '@angular/core';
import { validatePasswordRules } from './rules/password-rules';

@Injectable({
  providedIn: 'root'
})
/**
 * Service-Klasse für das Generieren und Verifizieren eines Passworts
 */
/**
 * Hierdurch erfüllte AFO's:
 *
 * A_25614-01 - Vorschlag von Passwörtern für das Schlüssel-Backup
 * A_25615 - Quelle des Zufalls für Vorschläge
 */
export class PasswordService {
  /**
   * Generiert ein Passwort aus 14 Zeichen mit mindestens einem Großbuchstabe,
   * einem Kleinbuchstaben, einer Zahl und einem Sonderzeichen
   */
  generatePassword(): string {
    const length = 14;
    const upperCase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const lowerCase = 'abcdefghijklmnopqrstuvwxyz';
    const symbols = '!@#$%^&*()_+[]{}|;:,.<>?/~';
    const allChars = lowerCase + upperCase + numbers + symbols;

    // Sicherstellung, dass aus jeder Kathegorie min. ein Zeichen im Passwort ist
    let password = '';
    const charGroups = [lowerCase, upperCase, numbers, symbols];
    charGroups.forEach(group => {
      password += this.getRandomChar(group);
    });

    // Zufälliges hinzufügen von Zeichen, bis die 14 Zeichen erreicht sind
    const remainingLength = length - password.length;
    const array = new Uint32Array(remainingLength);
    // GS-A_4367 - Sicherheitstechnische Anforderungen für Zufallszahlengeneratoren erfüllt.
    window.crypto.getRandomValues(array); // relevant für A_25615

    for (let i = 0; i < remainingLength; i++) {
      const randomIndex = array[i] % allChars.length;
      password += allChars.charAt(randomIndex);
    }

    // Mischt das Passwort zufällig, damit die ersten vier festgelegten Zeichen nicht immer am Anfang sind
    password = this.shuffleString(password);

    return password;
  }

  displayPasswordErrorMessage(messages: string[]): void {
    const errorMessageElement = document.getElementById('passwordError');
    if (errorMessageElement) {
      errorMessageElement.style.display = 'block';
      errorMessageElement.innerHTML = messages.join('<br>');
    }
  }

  checkPassword(verificationPassword: string | null | undefined): string[] {
    const result = validatePasswordRules(verificationPassword);

    if (!result.valid) {
      this.displayPasswordErrorMessage(result.errors);
    }

    return result.errors;
  }

  // Hilfsmethode für zufällige Zeichen
  private getRandomChar(chars: string): string {
    // GS-A_4367 - Sicherheitstechnische Anforderungen für Zufallszahlengeneratoren erfüllt.
    const index = window.crypto.getRandomValues(new Uint32Array(1))[0] % chars.length; // relevant für A_25615
    return chars.charAt(index);
  }

  private shuffleString(str: string): string {
    const array = str.split('');
    for (let i = array.length - 1; i > 0; i--) {
      // GS-A_4367 - Sicherheitstechnische Anforderungen für Zufallszahlengeneratoren erfüllt.
      const j = window.crypto.getRandomValues(new Uint32Array(1))[0] % (i + 1); // relevant für A_25615
      [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
    return array.join('');
  }
}
